export default "__VITE_ASSET__6cqanpzF__"